(function () {
    'use strict';

    angular.module("imApp").factory("stockCountDatasService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 963,
                    parameters: parms || {}
                });
            },
            listStockCountDatas: function (parms) {
                return $ihttp.post({
                    method: 965,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
